export default "__VITE_ASSET__CQNmgJTO__"